import { Box } from '@material-ui/core';
import { Select } from '@backstage/core-components';
import { useEntityList, EntityFilter } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';
import { useState } from 'react';

class CrossplaneReadyEntityFilter implements EntityFilter {
  constructor(readonly value: string) {}

  filterEntity(entity: Entity): boolean {
    if (entity.kind !== 'Resource') return true;
    const ready =
      entity.metadata.annotations?.['ciandtspike.io/crossplane-ready'] ??
      'Unknown';
    if (this.value === 'all') return true;
    if (this.value === 'ready') return ready === 'True';
    if (this.value === 'not-ready') return ready === 'False';
    return true;
  }
}

export const CrossplaneReadyFilterComponent = () => {
  const { filters, updateFilters } = useEntityList();
  const [selected, setSelected] = useState<string>('all');

  const kindFilter = (filters as any).kind?.value;
  if (kindFilter && kindFilter.toLowerCase() !== 'resource') {
    return null;
  }

  const items = [
    { value: 'all', label: 'All' },
    { value: 'ready', label: 'Ready' },
    { value: 'not-ready', label: 'Not Ready' },
  ];

  return (
    <Box pb={1} pt={1}>
      <Select
        label="Crossplane Ready"
        items={items}
        selected={selected}
        onChange={value => {
          const val = String(value);
          setSelected(val);
          updateFilters({
            crossplaneReady:
              val === 'all' ? undefined : new CrossplaneReadyEntityFilter(val),
          } as any);
        }}
      />
    </Box>
  );
};
